import React, { useState, useCallback, useEffect } from 'react';
import { getBeyondBirdImageSrc } from './beyondBirdMemoryLayout';
import { getCachedBirdPopVisualStyle } from './beyondBirdPopVisual';

/**
 * Bird portrait scaled to fill circular tree holes despite uneven padding in source PNGs.
 *
 * @param {object} props
 * @param {number} props.birdId 1–7
 * @param {string} props.className
 * @param {string} [props.alt]
 */
export default function BeyondBirdPopImage({ birdId, className, alt = '' }) {
  const [visualStyle, setVisualStyle] = useState(null);

  useEffect(() => {
    setVisualStyle(null);
  }, [birdId]);

  const handleLoad = useCallback(
    (e) => {
      const style = getCachedBirdPopVisualStyle(birdId, e.currentTarget);
      setVisualStyle(style);
    },
    [birdId]
  );

  const inlineStyle =
    visualStyle != null
      ? {
          transform: `scale(${visualStyle.scale})`,
          transformOrigin: `${visualStyle.originX} ${visualStyle.originY}`,
          opacity: 1,
        }
      : { opacity: 0 };

  return (
    <img
      src={getBeyondBirdImageSrc(birdId)}
      alt={alt}
      className={className}
      style={inlineStyle}
      draggable={false}
      onLoad={handleLoad}
    />
  );
}
